import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText } from "@prismicio/react";
import { PrismicNextLink, PrismicNextImage } from '@prismicio/next'

/**
 * Props for `LargeImage`.
 */
export type LargeImageProps = SliceComponentProps<Content.LargeImageSlice>;

/**
 * Component for "LargeImage" Slices.
 */
const LargeImage: FC<LargeImageProps> = ({ slice }) => {


  const cleanImageUrl = (field: any) => {
    if (!field || !field.url) return field;
    const url = new URL(field.url);
    return {
      ...field,
      url: `${url.origin}${url.pathname}`
    };
  };

  const ctaText = slice.primary.button_text || "Learn more";
  const ctaDestination = ((slice.primary.link as any)?.url || "").split("?")[0].split("#")[0].split("/").filter(Boolean).pop()?.replace(/-/g, " ");
  const ctaLabel = ctaDestination ? `Learn more about ${ctaDestination}` : ctaText;
  const hiddenSuffix = /^(learn more|read more)$/i.test(ctaText.trim()) && ctaDestination ? ` about ${ctaDestination}` : "";

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation} 
      className="px-4 md:px-8 lg:px-12 xl:px-0 font-fellix"
    >
      <div className={slice.primary.inset_image_text_under === true ? "large-image inset-text-under" : "large-image"}>
      <div className={slice.primary.style ? "inner-wrapper "+slice.primary.style : "inner-wrapper"}>
        {slice.primary.image && slice.primary.image.url ?
          <picture>
            {slice.primary.full_size_image === true ?
            <PrismicNextImage field={cleanImageUrl(slice.primary.image)}  imgixParams={{ auto: ['compress'], fm: 'webp', q: 55, fit: 'max' }}  fallbackAlt="" className="w-full object-cover" sizes="100vw" priority/>
            :<></>}
          </picture>
        : null}
          <div className={`${slice.primary.white_text === true ? "text-white" : ""} max-w-[1280px] mx-auto text-center`}>
            {slice.primary.inline_image && slice.primary.inline_image.url ?
            <PrismicNextImage className="w-full mx-auto max-w-[640px] aspect-video object-cover my-16" field={cleanImageUrl(slice.primary.inline_image)}  imgixParams={{ auto: ['compress'], fm: 'webp', q: 55, fit: 'max' }} fallbackAlt="" sizes="(min-width: 768px) 640px, 100vw" priority/>
            : null}
            <PrismicRichText field={slice.primary.headline}/>
            <div className="prose prose-h2:m-0 prose-h2:my-6 prose-p:text-[28px] prose-p:leading-[36px] prose-p:m-0 prose-p:mb-4 max-w-[650px] prose-a:text-blue-500 prose-a:no-underline prose-a:hover:underline mx-auto pb-16">
              <PrismicRichText field={slice.primary.paragraph}/>
              {slice.primary.link.link_type !== "Any" ? // This one is an internal link to a prismic page
                <PrismicNextLink field={slice.primary.link} aria-label={ctaLabel} className="jade-hollow">
                  {slice.primary.button_text}
                  {hiddenSuffix ? <span className="sr-only">{hiddenSuffix}</span> : null}
                </PrismicNextLink>
              :<></>}
            </div>
          </div>
          {slice.primary.fineprint ? 
          <div className="fineprint">
            <PrismicRichText field={slice.primary.fineprint}/>
          </div>
          : <></>}
        </div>
    </div>
    </section>
  );
};

export default LargeImage;
